import { axiosInstance } from "../../../Services";

export const AddInventoryProducts = async (data) => {
    try {
      const res = await axiosInstance.post("/rsform/inventories", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  };